import { BRAND_LOGO_SRC } from "@/lib/brand";

const FALLBACKS = [
  "/assets/safari-hero-1.png",
  "/assets/safari-hero-2.png",
];

/** Phone mockup — uses shipped safari hero assets when dedicated PNGs are absent. */
export default function LandingPhone({ variant = 0, alt, className = "", testId }) {
  const src = FALLBACKS[variant % FALLBACKS.length];
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid={testId}
      onError={(e) => {
        if (e.currentTarget.src !== BRAND_LOGO_SRC) {
          e.currentTarget.src = BRAND_LOGO_SRC;
        }
      }}
    />
  );
}
